import { Component, Input, Output, EventEmitter, ViewChild, Renderer2, ElementRef, AfterViewInit, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common'; import { ProductService } from 'src/app/services/product.service'; import { SkeletonModule } from 'primeng/skeleton';
import { AnnotatorComponent } from 'ngx-image-annotation'; import { firstValueFrom } from 'rxjs'; import { FormsModule } from '@angular/forms'; import { ChangeDetectorRef } from '@angular/core';
import { DropdownModule } from 'primeng/dropdown'; import { SidebarModule } from 'primeng/sidebar'; import { ButtonModule } from 'primeng/button'; import { CheckboxModule } from 'primeng/checkbox';

import { Hotspot, ProductCard, HotspotProductState, HotspotAttribute, HotspotVariant } from 'src/app/models/hotspot.model'; // seu modelo compartilhado
@Component({
  selector: 'app-hotspot-editor',
  standalone: true,
  imports: [CommonModule, AnnotatorComponent, DropdownModule, FormsModule, SidebarModule, ButtonModule, SkeletonModule, CheckboxModule],
  templateUrl: './hotspot-editor.component.html',
  styleUrls: ['./hotspot-editor.component.scss'],
  providers: [
    ProductService,
  ]
})
export class HotspotEditorComponent implements AfterViewInit, OnDestroy, OnChanges {
  @Input() imageUrl!: string;
  @Input() markerType: 'number' | 'dot' = 'number';
  @Input() enabled = true;
  @Input() enabledAsset = true;
  @Input() hotspots: Hotspot[] = [];
  @Input() productMap: Record<string | number, ProductCard> = {};
  //////////////////////////////
  @Input() set editable(value: boolean | 0 | 1) {
    console.log('editable')
    this.canEdit = value === true || value === 1;
    this.updateShortcuts();
  }
  canEdit = true;
  shortcuts = { del: true, bksp: true };
  /////////////////////////////
  private updateShortcuts() {
    // objeto estável por ciclo; só muda quando canEdit mudar de fato
    this.shortcuts = {
      del: this.canEdit,
      bksp: this.canEdit,
    };
  }


  @Input() fit: 'cover' | 'contain' = 'cover';

  @Output() hotspotsChange = new EventEmitter<Hotspot[]>();
  @Output() productClicked = new EventEmitter<ProductCard>();
  @Output() addToCartFromHotspot = new EventEmitter<HotspotProductState[]>();

  @ViewChild('host', { read: ElementRef }) host!: ElementRef<HTMLElement>;

  pop?: { i: number; xPct: number; yPct: number; data: HotspotProductState; locked: boolean };

  productStateMap: Record<string | number, HotspotProductState> = {};

  // ---- sidebar interna (shop-the-look do filho) ----
  shopVisible = false;
  shopProducts: HotspotProductState[] = [];
  shopSelection: Record<string | number, boolean> = {};

  get selectedShopCount(): number {
    return this.shopProducts.reduce((acc, p) => {
      const key = (p.sku ?? p.id) as any;
      return acc + (this.shopSelection[key] ? 1 : 0);
    }, 0);
  }

  public popoverCloseTimeout: any = null;

  private natW = 0;
  private natH = 0;

  // DRAG
  public draggingIndex: number | null = null;
  private boundMove = (e: PointerEvent) => this.onPointerMove(e);
  private boundUp = (e: PointerEvent) => this.endDrag(e);

  constructor(
    private el: ElementRef<HTMLElement>,
    private productService: ProductService,
    private cdr: ChangeDetectorRef,
    private rd: Renderer2
  ) { }


  ngAfterViewInit(): void {
    console.log('ngAfterViewInit')
    //this.applySvgFit();
    const img = new Image();
    img.src = this.imageUrl;
    img.onload = () => {
      this.natW = img.naturalWidth || 0;
      this.natH = img.naturalHeight || 0;
    };
  }

  onAnnotatorReady(): void {
    const host = this.host?.nativeElement || this.el.nativeElement;
    const annotatorEl = host.querySelector('annotator') as HTMLElement | null;
    if (!annotatorEl) return;

    const innerDiv = annotatorEl.querySelector('div') as HTMLDivElement | null;
    const svg = annotatorEl.querySelector('svg') as SVGElement | null;
    const img = svg?.querySelector('image') as SVGImageElement | null;

    if (!innerDiv || !svg) return;

    // wrapper ocupa o container
    innerDiv.removeAttribute('style');
    innerDiv.style.position = 'relative';
    innerDiv.style.width = '100%';
    innerDiv.style.height = '100%';
    innerDiv.style.maxWidth = '100%';
    innerDiv.style.maxHeight = '100%';
    innerDiv.style.overflow = 'hidden';
    innerDiv.style.background = 'transparent';
    innerDiv.style.borderRadius = '12px';

    // garante viewBox
    if (!svg.getAttribute('viewBox')) {
      const w = parseFloat(svg.getAttribute('width') || '0') || 100;
      const h = parseFloat(svg.getAttribute('height') || '0') || 100;
      svg.setAttribute('viewBox', `0 0 ${w} ${h}`);
    }

    svg.removeAttribute('width');
    svg.removeAttribute('height');

    svg.style.width = '100%';
    svg.style.height = '100%';
    svg.style.display = 'block';
    svg.style.borderRadius = '12px';
    svg.style.overflow = 'hidden';

    // decide se quer cover ou contain
    const mode = this.fit === 'cover'
      ? 'xMidYMid slice' // preenche, corta bordas
      : 'xMidYMid meet'; // tudo dentro, pode sobrar espaço

    svg.setAttribute('preserveAspectRatio', mode);

    if (img) {
      img.removeAttribute('width');
      img.removeAttribute('height');

      // deixa o image ocupar o viewport do svg;
      // preserveAspectRatio resolve o "primeiro que bate 100%"
      img.setAttribute('x', '0');
      img.setAttribute('y', '0');
      img.setAttribute('width', '100%');
      img.setAttribute('height', '100%');
      img.setAttribute('preserveAspectRatio', mode);
    }
  }

  ngOnDestroy(): void {
    this.detachListeners();
  }

  // ---------- helpers ----------
  private toPct(px: number, base: number) {
    if (!base) return 0;
    return Math.max(0, Math.min(100, (px / base) * 100));
  }

  // ---------- annotator rectangle -> dot ----------
  onAddRect(evt: any) {
    if (!this.enabled || !this.canEdit) return;
    const rect = evt && typeof evt === 'object' && 'x' in evt ? evt : null;
    if (!rect) return;
    const iw = this.natW || rect.imageWidth || 1;
    const ih = this.natH || rect.imageHeight || 1;
    const xPct = this.toPct(rect.x, iw);
    const yPct = this.toPct(rect.y, ih);
    const hot: Hotspot = { xPct, yPct, wPct: 2, hPct: 2 };
    this.hotspots = [...this.hotspots, hot];
    this.hotspotsChange.emit(this.hotspots);
  }

  // ---------- drag ----------
  startDrag(ev: PointerEvent, index: number) {
    console.log('startDrag')
    if (!this.enabled || !this.canEdit) return;
    this.draggingIndex = index;
    (ev.target as HTMLElement).setPointerCapture?.(ev.pointerId);
    window.addEventListener('pointermove', this.boundMove);
    window.addEventListener('pointerup', this.boundUp);
    // ao começar drag, esconda o popover (se não estiver travado)
    if (this.pop && !this.pop.locked) this.pop = undefined;
  }

  get isDragging(): boolean {
    return this.draggingIndex !== null;
  }

  private onPointerMove(ev: PointerEvent) {
    if (this.draggingIndex == null) return;
    const hostRect = this.host.nativeElement.getBoundingClientRect();
    const x = (ev.clientX - hostRect.left) / hostRect.width;
    const y = (ev.clientY - hostRect.top) / hostRect.height;
    const xPct = Math.max(0, Math.min(100, x * 100));
    const yPct = Math.max(0, Math.min(100, y * 100));
    const copy = [...this.hotspots];
    const prev = copy[this.draggingIndex];
    copy[this.draggingIndex] = { ...prev, xPct, yPct };
    this.hotspots = copy;
    this.hotspotsChange.emit(this.hotspots);
  }

  //////////////////////////////
  @Output() hotspotDrop = new EventEmitter<{
    index: number;
    productId?: string | number;
    xPct: number;
    yPct: number;
  }>();

  private endDrag(_ev: PointerEvent) {
    const i = this.draggingIndex;
    this.draggingIndex = null;
    this.detachListeners();
    if (i != null) {
      const h = this.hotspots[i];
      // emite o ponto final
      this.hotspotDrop.emit({ index: i, productId: h.productId, xPct: h.xPct, yPct: h.yPct });
    }
  }
  //////////////////////////////

  private detachListeners() {
    window.removeEventListener('pointermove', this.boundMove);
    window.removeEventListener('pointerup', this.boundUp);
  }

  // ---------- popover handlers ----------
  async openCard(i: number, lock = false) {
    if (!this.enabled) return;

    if (this.isDragging) return;

    const h = this.hotspots[i];
    if (!h || h.productId == null) return;


    const data = this.productStateMap[h.productId as any];
    if (!data || data.show === false) return;

    this.cancelPopoverClose();

    const x = Math.max(6, Math.min(94, h.xPct));
    const y = Math.max(10, Math.min(90, h.yPct));

    this.pop = {
      i,
      xPct: x,
      yPct: y,
      data,
      locked: lock || (this.pop?.locked ?? false),
    };
  }

  closeCard(force = false, delay = 0) {
    this.cancelPopoverClose();
    if (!this.pop) return;
    if (this.pop.locked && !force) return;

    if (delay > 0) {
      this.popoverCloseTimeout = setTimeout(() => {
        this.pop = undefined;
        this.popoverCloseTimeout = null;
      }, delay);
    } else {
      this.pop = undefined;
    }
  }

  toggleLock(i: number) {
    if (!this.canEdit) return;

    // 🚫 ignorar clique se estiver arrastando
    if (this.isDragging) return;

    // se clicar em outro ponto, abre travado nele
    if (!this.pop || this.pop.i !== i) {
      this.openCard(i, true);
      return;
    }

    // se clicar no mesmo, alterna lock
    this.pop = { ...this.pop, locked: !this.pop.locked };
    if (!this.pop.locked) {
      this.closeCard(true); // agora pode fechar
    }
  }

  isVisible(h: Hotspot): boolean {
    const p = this.productMap[h.productId as any];
    // se não tiver no mapa, não mostra; se show = false, não mostra
    return !!(p && p.show !== false);
  }


  public cancelPopoverClose() {
    if (this.popoverCloseTimeout) {
      clearTimeout(this.popoverCloseTimeout);
      this.popoverCloseTimeout = null;
    }
  }
  private schedulePopoverClose(delay: number = 200) {
    this.cancelPopoverClose()

    this.popoverCloseTimeout = setTimeout(() => {
      // se tiver dropdown aberto, não fecha
      if (this.dropdownOpen) return;

      // se tiver pop travado, não fecha
      if (this.pop?.locked) return;

      this.pop = undefined;
      this.popoverCloseTimeout = null;
    }, delay);
  }
  onPopoverMouseLeave() {
    this.schedulePopoverClose(200);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['productMap']) {
      this.syncProductMap();
    }
  }
  private syncProductMap() {
    if (!this.productMap) return;

    Object.entries(this.productMap).forEach(([key, card]) => {
      const id = key as any;
      const base: HotspotProductState = {
        ...(card as ProductCard),
        sku: (card as any).sku ?? id,
        loading: false,
        loaded: false,
        selectedAttributes: {},
      };

      if (!this.productStateMap[id]) {
        this.productStateMap[id] = base;
      } else {
        this.productStateMap[id] = {
          ...this.productStateMap[id],
          ...base,
        };
      }
    });
  }

  private async ensureDetails(productId: string | number): Promise<void> {
    console.log('ensureDetails 1')
    const state = this.productStateMap[productId];
    if (!state) return;

    // deixa rodar novamente se precisar; só evita corrida simultânea
    if (state.loading) return;

    state.loading = true;
    this.cdr.detectChanges();

    if (!state.selectedAttributes) state.selectedAttributes = {};
    const sku = String(state.sku ?? productId);
    console.log('prods')
    try {
      const detailResp = await firstValueFrom(this.productService.getDetailProduct(sku));
      console.log(detailResp)
      const product = detailResp.product;

      const childrenResp = await firstValueFrom(this.productService.getChildremProducts(sku));
      console.log(childrenResp)
      const children: HotspotVariant[] = childrenResp.children || [];

      const attrsResp = await firstValueFrom(this.productService.getChildremProductsAttributes(sku));
      console.log(attrsResp)
      const attributes = this.mapAttributes(attrsResp.attributes);

      state.attributes = attributes;
      state.variants = children;
      state.selectedAttributes = {};
      state.selectedVariant = null;

      const basePrice = product?.price ?? (children[0]?.price ?? state.price);
      const baseCompare = product?.compare_at_price ?? (children[0]?.compare_at_price ?? state.compare_at_price);

      if (basePrice != null) state.price = Number(basePrice);
      if (baseCompare != null) state.compare_at_price = Number(baseCompare);

      state.loaded = true;
    } catch (err) {
      console.error('❌ Erro ao carregar produto do hotspot', err);
      state.loaded = false;
    } finally {
      state.loading = false;
      this.cdr.detectChanges();
    }
  }



  private mapAttributes(apiAttrs: any[]): HotspotAttribute[] {
    const map: Record<string, Set<string>> = {};

    (apiAttrs || []).forEach((item: any) => {
      const node = item?.node || item;
      if (!node) return;

      const selectedOptions = node.selectedOptions || [];
      selectedOptions.forEach((opt: any) => {
        if (!opt?.name) return;
        const attrName = opt.name;
        const value = opt.value || node.title;
        if (!map[attrName]) map[attrName] = new Set<string>();
        if (value) map[attrName].add(String(value));
      });
    });

    return Object
      .entries(map)
      // 🔥 só mantém atributos que têm MAIS de um valor possível
      .filter(([name, set]) => set.size > 1)
      .map(([name, set]) => {
        const values = Array.from(set);
        return {
          name,
          values,
          options: [
            { label: name, value: null, disabled: true }, // placeholder
            ...values.map(v => ({ label: v, value: v })),
          ],
        } as any;
      });
  }



  toDropdownOptions(values: string[]) {
    console.log('toDropdownOptions')
    return values.map(v => ({ label: v, value: v }));
  }

  hasDiscount(p: HotspotProductState): boolean {
    const price = Number(p.price ?? 0);
    const compare = Number(p.compare_at_price ?? 0);
    return !!compare && compare > price;
  }

  onAttrChange(product: HotspotProductState, attrName: string, value: string) {
    if (!product.selectedAttributes) {
      product.selectedAttributes = {};
    }
    product.selectedAttributes[attrName] = value;

    const key = String(product.sku ?? product.id);

    if (!product.variants || !product.variants.length) {
      // não tem variações: limpa erro se existir
      if (this.attrErrors[key]) delete this.attrErrors[key];
      return;
    }

    const match = product.variants.find(variant =>
      (variant.selectedOptions || []).every(opt =>
        product.selectedAttributes![opt.name] === opt.value
      )
    );

    if (!match) {
      product.selectedVariant = undefined;
      this.attrErrors[key] = 'Combinação de variação indisponível.';
      this.cdr.detectChanges();
      return;
    }

    // 🔥 Verifica estoque da variante
    const tracked = (match as any).tracked;
    const qty = Number((match as any).inventory_quantity ?? 0);

    if (tracked && qty <= 0) {
      product.selectedVariant = undefined; // não consideramos válida
      this.attrErrors[key] = 'Sem estoque para essa combinação.';
      this.cdr.detectChanges();
      return;
    }

    // ✅ Combinação válida e com estoque
    product.selectedVariant = match;
    product.price = Number(match.price);
    if (match.compare_at_price != null) {
      product.compare_at_price = Number(match.compare_at_price);
    }

    if (this.attrErrors[key]) {
      delete this.attrErrors[key];
    }

    this.cdr.detectChanges();
  }



  dropdownOpen = false;

  onDropdownOpen() {
    this.dropdownOpen = true;
  }

  onDropdownClose() {
    setTimeout(() => {
      this.dropdownOpen = false;
    });
  }




  async openShopForCurrent() { // shopVisible
    if (!this.pop) return;

    this.cancelPopoverClose();

    const id = (this.pop.data.sku ?? this.pop.data.id) as any;
    const state = this.productStateMap[id];
    if (!state) return;

    this.shopVisible = true;

    // snapshot inicial com skeleton
    this.shopProducts = [{
      ...state,
      loading: true,
      loaded: false,
    }];
    this.shopSelection = { [id]: true };
    this.cdr.detectChanges();

    await this.ensureDetails(id);

    const updated = this.productStateMap[id];
    if (updated) {
      this.shopProducts = [{
        ...updated,
        loading: false,
      }];
    }
    this.cdr.detectChanges();
  }






  onShopHide() {
    this.shopVisible = false;
    this.shopProducts = [];
    this.shopSelection = {};
  }

  // 🔴 map de erros por produto (key = sku/id)
  attrErrors: Record<string, string> = {};

  addSelectedToCart() {
    this.attrErrors = {};

    const selected = this.shopProducts.filter(p => {
      const key = (p.sku ?? p.id) as any;
      return this.shopSelection[key];
    });

    if (!selected.length) return;

    let hasInvalid = false;
    const valid: HotspotProductState[] = [];

    // 🔹 Lê o carrinho local UMA vez
    const cartItems = this.getCartItemsFromStorage();

    for (const p of selected) {
      const key = String(p.sku ?? p.id);
      // sem atributos = vai direto (sem controle de variante)
      if (!p.attributes || !p.attributes.length) {
        if (p.variants && p.variants.length === 1 && !p.selectedVariant) {
          p.selectedVariant = p.variants[0];
        }
        valid.push(p);
        continue;
      }
      const selectedAttrs = p.selectedAttributes || {};

      const missing = p.attributes
        .filter(attr => !selectedAttrs[attr.name])
        .map(attr => attr.name);

      if (missing.length) {
        hasInvalid = true;
        this.attrErrors[key] = `Selecione: ${missing.join(', ')}.`;
        continue;
      }
      const match = (p.variants || []).find(variant =>
        (variant.selectedOptions || []).every(opt =>
          selectedAttrs[opt.name] === opt.value
        )
      );

      if (!match) {
        hasInvalid = true;
        this.attrErrors[key] = 'Combinação de variação indisponível.';
        continue;
      }

      // 🔥 Estoque da variante
      const tracked = (match as any).tracked;
      const stock = Number((match as any).inventory_quantity ?? 0);

      if (tracked) {
        // quantidade que o usuário quer adicionar AGORA (no Shop the Look é sempre 1)
        const toAddNow = 1;

        // quanto JÁ TEM dessa variante no carrinho (localStorage)
        const alreadyInCart = this.getCartQtyForVariant(match, cartItems);

        if (alreadyInCart + toAddNow > stock) {
          hasInvalid = true;
          this.attrErrors[key] = 'Quantidade máxima já adicionada ao carrinho.';
          continue;
        }
      }

      // ok, variante válida e com estoque disponível
      p.selectedVariant = match;
      valid.push(p);
    }

    if (hasInvalid) {
      this.cdr.detectChanges();
      return;
    }

    if (!valid.length) return;

    this.addToCartFromHotspot.emit(valid);
  }

  private getCartItemsFromStorage(): any[] {
    if (typeof window === 'undefined') return [];

    try {
      const raw = localStorage.getItem('ss_shopping_cart');
      if (!raw) return [];
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      console.warn('Erro ao ler ss_shopping_cart', e);
      return [];
    }
  }
  private getCartQtyForVariant(match: any, cartItems: any[]): number {
    if (!match) return 0;

    const gid = String(match.id ?? '');
    const numeric = gid.split('/').pop(); // "45049903644850"

    return cartItems
      .filter(ci =>
        String(ci.id) === numeric ||
        String(ci.variant_id) === gid
      )
      .reduce((sum, ci) => sum + Number(ci.quantity ?? 0), 0);
  }


}
